<template>
  <div>
    <AppHeader title="传感器事件"/>
    <Panel class="tabs search-panel" :title="false">
      <div slot="content">
        <div class="line">
          <input class="line-input" id="eqName" @click="showEquipments" v-model="equipment"
                 @keydown="preventDefault" placeholder="仪器名称"/>
          <input class="line-input mt10" id="beginAt" @click="showPicker('beginAt')" :value="dateFormat(beginAt)"
                 @keydown="preventDefault" placeholder="开始时间"/>
          <input class="line-input mt10" id="endAt" @click="showPicker('endAt')" :value="dateFormat(endAt)"
                 @keydown="preventDefault" placeholder="结束时间"/>
          <div class="flex-dir-row mt10">
            <div class="flex-item-auto">
              <input class="line-input" id="code" @click="showCodes" :value="code" @keydown="preventDefault" placeholder="传感器代码"/>
            </div>
            <div class="btn btn-small green ml5" @click="reset">重设</div>
            <div class="btn btn-small green ml5" @click="initEvents">查询</div>
          </div>
        </div>
      </div>
    </Panel>
    <Panel class="tabs mt15" :title="false">
      <div slot="content" v-infinite-scroll="loadEvents"
           infinite-scroll-disabled="loading"
           infinite-scroll-distance="10">
        <div class="line" v-for="(se,idx) of sensorEvents">
          <div class="flex-dir-row" style="font-weight: 500">
            <div class="line-label">事件标题：</div>
            {{ se.title }}
          </div>
          <div class="flex-dir-row">
            <div class="line-label">仪器名称：</div>
            {{ se.equipment }}
          </div>
          <div class="flex-dir-row">
            <div class="line-label">传感器代码：</div>
            {{ se.name }}
          </div>
          <div class="flex-dir-row">
            <div class="line-label">事件级别：</div>
            {{ se.level }}
          </div>
          <div class="flex-dir-row">
            <div class="line-label">发生时间：</div>
            {{ se.happenAt }}
          </div>
          <div>
            <div class="btn btn-small  ml5" v-if="se.needHandle && se.remark==null" style="background-color: #FF9F00;float: right" @click="openRemoveAlarm(se.equipmentId,se.id,se.equipment)" >处理报警</div>
            <div class="btn btn-small  ml5" v-if="se.needHandle && se.remark!=null && se.remark!=''" style="background-color: #FF9F00;float: right" @click="viewAlarm(se.equipmentId,se.remark,se.id,se.equipment)" >解除警报原因</div>
          </div>


        </div>
        <div class="line text-center" v-if="sensorEvents.length===0">暂无记录</div>
      </div>
    </Panel>


    <mt-popup
        v-model="popupbaojing"
        popup-transition="popup-fade"
        class="sensor-popup"
    >
      <div class="popup-header">处理报警</div>
      <div class="popup-content" style="height: 300px">
        <div class="popup-body" style="height: 100%">
          <textarea class="popup-textarea" style="height: 100%" v-model="baojingText" placeholder="请输入解除报警原因"></textarea>
        </div>
      </div>
      <div class="popup-footer" style="margin-bottom: 15px;padding: 0 15px;display: flex;justify-content: space-between;">
        <mt-button style="background-color: #FF9F00;color: wheat;font-size: 0.16rem"  v-if="existController" @click="openController(eqId,popupEqName)">远程控制</mt-button>
        <mt-button type="primary" v-if="alreadyRemark" @click="removeAlarm(eqId,popupEqName)">确定解除报警</mt-button>
      </div>
    </mt-popup>




    <!-- 弹出页面 -->
    <mt-popup
        v-model="popupVisible"
        popup-transition="popup-fade"
        class="sensor-popup"
    >
      <div class="popup-header">执行操作</div>
      <div class="popup-content">
        <p style="margin-bottom: 15px;" v-if="popupController!=null">{{popupEqName}}支持以下控制指令，请按需选择执行：</p>
        <div class="popup-body" v-if="popupController!=null">
            <div class="command-box" v-for="item in popupController" @click="showConfirmation(item)">
              <div class="command-name">{{item.sensorName}}</div>
              <div class="command-type">{{item.controllerType}}</div>
            </div>
        </div>
        <div class="line text-center" v-if="popupController==null || popupController.length==0">{{popupEqName}}暂未配置远程控制指令，请先配置</div>

      </div>
    </mt-popup>

    <mt-popup
        v-model="confirmationVisible"
        popup-transition="popup-fade"
        class="sensor-popup"
    >

      <div class="popup-content popup-2" style="text-align: center;">
        <img src="../assets/images/icon_wen.png" style="display: block;width: 15%;height: 15%;margin: 0 auto">
        <p class="p-1">对{{selectedItem.sensorName}}执行“{{selectedItem.controllerType}}”指令?</p>
        <p class="p-2">确认后，将向该传感器下发指令并执行</p>
        <div  style="margin-top: 30%">
          <mt-button style="width: 80%" type="primary" @click="executeCommand">确认执行</mt-button>
        </div>
        <div style="margin-top: 4%">
          <mt-button style="width: 80%" type="" @click="confirmationVisible = false">取消</mt-button>
        </div>
      </div>
    </mt-popup>


    <mt-popup
        v-model="confirmationSuccess"
        popup-transition="popup-fade"
        class="sensor-popup"
    >
      <div class="popup-content popup-2" style="text-align: center;">
        <img src="../assets/images/icon_chenggong.png" style="display: block;width: 15%;height: 15%;margin: 0 auto">
        <p class="p-1">指令已下发</p>
        <div  style="margin-top: 30%">
          <mt-button style="width: 80%" type="primary" @click="confirmationSuccess=false;confirmationVisible = false;popupVisible=false">好的</mt-button>
        </div>

      </div>
    </mt-popup>

    <mt-datetime-picker
        v-model="dateVal"
        type="datetime"
        @confirm="handleConfirm"
        ref="picker"
    >
    </mt-datetime-picker>

    <mt-popup
        v-model="codesVisible"
        position="bottom"
    >
      <mt-picker :slots="codeSlots" @change="onCodeChange" v-if="codesVisible"></mt-picker>
    </mt-popup>

    <mt-popup
        v-model="equipmentsVisible"
        position="bottom"
    >
      <mt-picker :slots="equipmentSlots" @change="onEquipmentChange" value-key="text" v-if="equipmentsVisible"></mt-picker>
    </mt-popup>

  </div>
</template>
<style scoped>
.popup-2{
  margin-top: 5%;
}
.p-1{
  font-weight: bold;
  font-size: 19px !important;
}
.p-2{
  color: #7d7d7d;
}
.command-box {
  display: inline-block;
  padding: 10px 20px;
  margin: 4px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: default;
}
.command-box:hover {
  cursor: pointer;
  background-color: #e0e0e0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.command-box:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.command-name {
  font-size: 14px;
  color: #333;
}
.command-type {
  font-size: 12px;
  color: #ff6600;
}
.command-title{
  margin: 10px 0 10px 20px;
}
.command-par{
  margin: 0 20px;
}
.sensor-popup {
  width: 90%;
  max-width: 500px;
  border-radius: 8px;
  overflow: hidden;
}
.popup-header {
  background-color: #f8f8f8;
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}
.popup-content {
  padding: 15px;
  background-color: white;
}

</style>
<script>
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";
import {InfiniteScroll, DatetimePicker, Picker, MessageBox} from 'mint-ui';

import {mapState} from 'vuex'
import sec from "@/plugins/user";

export default {
  components: {
    AppHeader,
    Panel,
    InfiniteScroll,
    DatetimePicker,
    Picker
  },
  data() {
    return {
      isAdmin:false,
      page: 1,
      sensorEvents: [],
      loading: false,
      noMore: false,
      beginAt: null,
      endAt: null,
      equipment: null,
      eqId: null,
      code: null,
      popupVisible: false,
      popupbaojing: false,
      popupEqName: null,
      sensorEventId: null,
      alreadyRemark: true,
      popupController:[],
      selectedItem: {}, // 用于存储选中的项
      confirmationVisible: false,
      confirmationSuccess:false,
      bakeLampState: '',
      bufferDisplayState: '',
      bufferDisplayState2: '',
      accessControlState: '',
      airConditionerState: '',
      codeSlots: [{values: ['menjin', 'wendu', 'shidu', 'voc', 'gonglv', 'huojing', 'dianyuan', 'action', 'kaiguan', 'pm2.5']}],
      codesVisible: false,
      baojingText: '',
      dateVal: new Date(),
      pickerField: '',
      existController: false,
      equipmentsVisible: false,
    }
  },
  computed: mapState({
    // 为了能够使用 `this` 获取局部状态，必须使用常规函数
    equipmentSlots(state) {
      return [{values: state.equipments}]
    }
  }),
  methods: {
    // clickController(sensorId,controllerType,sensorName){
    //
    // },
    openRemoveAlarm(equipmentId,sensorId,eq){
    this.alreadyRemark=true
      this.$http.post('/portal/sensorEvent/hasAdminControllerData?equipmentId='+equipmentId).then(res => {
        if(res.success && res.data>0){
          this.existController=true
          this.popupEqName=eq
          this.eqId=equipmentId
          this.sensorEventId=sensorId
        }else {
          this.existController=false
          this.popupEqName=null
          this.eqId=null
        }
      })
      this.popupbaojing = true
    },
    removeAlarm(){
      var that=this
      if(this.baojingText==null || this.baojingText==''){
        this.$toast('请输入报警信息')
      }
      //确定要解除改报警吗
      MessageBox.confirm('确定要解除该警报吗?').then(action => {
        that.$http.post('/portal/sensorEvent/removeAlarm?id='+that.sensorEventId+"&remark="+that.baojingText).then(res => {
          if (res.success){
            that.$toast('解除成功')
            that.popupbaojing = false
            that.eqId=null
            that.baojingText=''
            that.initEvents()

          }
        })
      })



    },
    viewAlarm(eqId,remark,sensorId,eq){

      this.$http.post('/portal/sensorEvent/hasAdminControllerData?equipmentId='+eqId).then(res => {
        if(res.success && res.data>0){
          this.existController=true
          this.popupEqName=eq
          this.eqId=eqId
          this.sensorEventId=sensorId
        }else {
          this.existController=false
          this.popupEqName=null
          this.eqId=null
        }
      })
      this.popupbaojing = true
      this.alreadyRemark=false
      this.baojingText= remark
    },
    showConfirmation(item) {
      console.log("item:",item)
      this.selectedItem = item;
      this.confirmationVisible = true;
    },
    executeCommand() {
      // 执行指令的逻辑，例如调用API
     this.$http.post('/portal/sensorEvent/controllerSensor?id='+this.selectedItem.sensorId+"&type="+this.selectedItem.controllerType).then(res => {
        if(res.success){
          this.confirmationSuccess = true
          this.confirmationVisible = false;
          this.popupVisible = false; // 可选：关闭主弹出框
        }else {
          this.confirmationVisible = false;

        }
     })
    },
    onEquipmentChange(picker, values) {
      this.equipment = values[0].text
      this.equipmentId = values[0].id
    },
    showEquipments() {
      this.equipmentsVisible = true
    },
    onCodeChange(picker, values) {
      this.code = values[0]
    },
    showCodes() {
      this.codesVisible = true
    },

    showPicker(pickerField) {
      this.dateVal = new Date()
      this.pickerField = pickerField
      this.$refs.picker.open()
    },
    handleConfirm(value) {
      if (this.pickerField === 'beginAt') {
        this.beginAt = this.$moment(value).valueOf()
      } else {
        this.endAt = this.$moment(value).valueOf()
      }
    },
    reset() {
      this.page = 1
      this.loading = false
      this.beginAt = null
      this.endAt = null
      this.code = ''
      this.equipment = ''
      this.equipmentId = ''
    },
    openController(id,eqName){
      // console.log( id)
      // this.popupEqName=eqName
      this.$http.post("/portal/sensorEvent/queryControllerList?id="+ id).then(res=>{
        if(res.success){
          this.popupController=res.data
          this.popupVisible=true
        }else {
          Toast(res.msg)
        }
      })
    },
    dateFormat(timestamp) {
      if (timestamp) {
        return this.$moment(timestamp).format('YY-MM-DD HH:mm')
      }
      return ''
    },
    initEvents() {
      this.sensorEvents = []
      this.page = 1
      this.noMore = false
      this.loadEvents()
    },
    loadEvents() {
      if (this.noMore) {
        return
      }
      const that = this
      this.loading = true
      let data = new FormData()
      data.append('page', `${this.page}`)
      data.append('limit', '20')
      this.equipmentId && data.append('equipmentId', this.equipmentId)
      this.beginAt && data.append('beginAt', `${this.beginAt}`)
      this.endAt && data.append('endAt', `${this.endAt}`)
      this.code && data.append('name', `${this.code}`)

      this.$http.post(`/portal/sensorEvent/query`, data).then(res => {
        if (res.data && res.data.length > 0) {
          that.sensorEvents = that.sensorEvents.concat(res.data)
          that.loading = false
          that.page = that.page + 1
          console.log(that.sensorEvents)
        } else {
          this.noMore = true
        }
      })
    },
    preventDefault(e) {
      e.preventDefault()
    }
  },
  mounted() {
    this.initEvents()
    this.isAdmin = sec.hasAnyRole('admin', 'allAdmin')

  }
}
</script>
